import React from 'react';

interface PageViewOptionsBarProps {
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
}

export function PageViewOptionsBar({ leftSlot, rightSlot }: PageViewOptionsBarProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div>{leftSlot}</div>
      <div>{rightSlot}</div>
    </div>
  );
}
